var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ValidationProvider', {
    staticClass: "form-group w-full",
    class: _vm.$attrs.class,
    attrs: {
      "mode": _vm.customValidate,
      "rules": _vm.rules,
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors,
          classes = _ref.classes;
        return [_vm.label ? _c('label', {
          staticClass: "block text-base font-normal mb-1"
        }, [_vm._v(" " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('b', {
          staticClass: "ml-1 text-red-600 font-bold"
        }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _c('div', {
          staticClass: "relative input-group"
        }, [_c('VueSelect', _vm._g({
          ref: "select",
          staticClass: "form-control",
          class: [{
            'tags-input': !_vm.search
          }],
          attrs: {
            "disabled": _vm.disabled,
            "options": _vm.paginated,
            "placeholder": _vm.placeholder,
            "multiple": "",
            "taggable": ""
          },
          on: {
            "close": _vm.onClose,
            "open": _vm.onOpen,
            "search": _vm.onSearch,
            "option:selected": _vm.onSelected
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function (_ref2) {
              var label = _ref2.label;
              return [_c('div', {
                class: [{
                  'font-bold': _vm.isSelectedOptionItem(label)
                }]
              }, [_vm._v(_vm._s(label))])];
            }
          }, {
            key: "no-options",
            fn: function (_ref3) {
              var searching = _ref3.searching;
              return [_vm.search ? _c('div', {
                staticClass: "px-3 py-2 text-center"
              }, [!_vm.loading ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("No items in select")))]) : _vm._e()]) : _c('div')];
            }
          }, {
            key: "list-footer",
            fn: function () {
              return [_c('li', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading"
                }],
                ref: "load",
                staticClass: "list-footer"
              }, [_c('i', {
                staticClass: "fa-solid fa-spin fa-circle-notch"
              }), _vm._v(" " + _vm._s(_vm.$t('Data loading')) + " ")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.dropdownValue,
            callback: function ($$v) {
              _vm.dropdownValue = $$v;
            },
            expression: "dropdownValue"
          }
        }, _vm.$listeners))], 1), _c('span', {
          staticClass: "text-xs text-gray-400"
        }, [_vm._v(_vm._s(_vm.$t("Type and press enter to create a tag")))]), _c('span', {
          staticClass: "text-xs text-red-600"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }